<template>
  <naj-box :title="local.inheritorData.title">
    <v-row>
      <v-col>
        <v-col cols="1">
          <naj-button
            style="margin-top: 26px;"
            square
            inputs-alignment
            :loading="isChecking"
            :disabled="(!isCheckingValidityValid)"
            @click="onValidateInheritor"
          >
            {{ local.inheritorData.checkInheritorData }}
          </naj-button>
        </v-col>
      </v-col>
    </v-row>
    <v-row
      v-if="!isChecking && isChecked && !formModel.isVerified"
      class="ma-1 mb-0 red--text"
    >
      {{ local.inheritorData.judgementCodeNotVerified }}
    </v-row>
    <v-row v-if="false && (formModel.heirsList|| [] ).length > 0">
      <naj-data-table
        :headers="headers"
        :items="formModel.heirsList"
        :no-data-text="local.common.noData"
        :disable-items-per-page="true"
        :pagination="false"
        :show-select="false"
        :title="local.inheritorData.title"
      >
      </naj-data-table>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { isProsecutor } from '../../../../helpers/utils';
const { mapActions, mapState } = createNamespacedHelpers('LawsuitModule');
export default {
  inject: ['$validator'],
  props: ['formModel'],
  data() {
    return {
      isChecking: false,
      isChecked: false,
      showHeirsModal: false,
      heirs: [],
      isProsecutor,
    };
  },
  computed: {
    ...mapState({
      casePartiesList: state => state.lawsuitRequest.caseParties,
      caseData: state => state.lawsuitRequest.case,
    }),
    isCheckingValidityValid() {
      return this.formModel.socialId;
    },
    casePartyAsProsecutor() {
      return this.isProsecutor(this.formModel);
    },

    headers() {
      return [
        {
          value: 'fullName',
          sortable: false,
          text: this.local.inheritorData.name,
        },
        {
          value: 'socialId',
          sortable: false,
          text: this.local.inheritorData.socialId,
        },
        {
          value: 'inheritorSocialId',
          sortable: false,
          text: this.local.inheritorData.inheritorSocialId,
        },
        {
          value: 'relationToDeceasedName',
          sortable: false,
          text: this.local.inheritorData.relationToDeceasedName,
        },
        {
          value: 'lifeStatusName',
          sortable: false,
          text: this.local.inheritorData.lifeStatusName,
        },
      ];
    },
  },
  watch: {
    'formModel.socialId'() {
      this.isChecked = false;
      this.changeVerification(false);
      this.formModel.heirsList = [];
    },
  },
  methods: {
    ...mapGlobalActions(['getDeceasedAndHeirsData', 'getDeceasedAndHeirsDataForDefendant']),
    ...mapActions([
      'checkPartyAuthentication',
    ]),
    onValidateInheritor() {
      this.isChecking = true;
      this.isChecked = true;
      this.getDeceasedAndHeirsDataForDefendant({ socialId: this.formModel.socialId })
        .then((res) => {
          if (res.data.deceased.socialId === this.formModel.socialId) {
            // prepare heirs data for authentication check
            const heirsData = res.data.heirs.map(heir => ({
              socialIdType: heir.socialIdTypeId,
              dateOfBirth: heir.dateOfBirth,
              caseClassificationId: this.caseData.caseClassificationIdNew,
            }));
            if (this.isProsecutor(this.formModel)) {
              // check authentication for all heirs at once
              this.checkPartyAuthentication(heirsData)
                .then((result) => {
                  // check if authentication failed
                  if (result === false) {
                    this.toaster.error(this.local.lawsuitRequest.authentication.invalidCasePartyRelatedToInheritor);
                  } else {
                    this.fillHeirsList(res.data.allHeirs);
                    this.toaster.success(this.local.common.verificationSucceeded, 2);
                    this.changeVerification(true);
                  }
                  this.$emit('inheritor-validated', true);
                })
                .catch((ex) => {
                  this.toaster.error(this.local.lawsuitRequest.authentication.checkPartyAuthenticationError);
                  this.isChecking = false;
                  this.changeVerification(false);
                });
            }
            else {
              // non-prosecutor: mark as validated without authentication
              this.fillHeirsList(res.data.allHeirs);
              this.toaster.success(this.local.common.verificationSucceeded, 2);
              this.changeVerification(true);
              this.$emit('inheritor-validated', true);
            }
          } else {
            this.toaster.error(this.local.inheritorData.mustUseInheritorSocialId);
            this.changeVerification(false);
          }
        })
        .catch(() => {
          this.toaster.error(`${this.local.inheritorData.title} غير صحيحة`);
          this.changeVerification(false);
        })
        .finally(() => (this.isChecking = false));
    },
    fillHeirsList(allHeirs) {
      this.heirs = allHeirs;
      this.heirs.forEach((element) => {
        if (element.lifeStatus) {
          this.$set(element, 'lifeStatusName', this.local.inheritorData.dead);
        } else {
          this.$set(element, 'lifeStatusName', this.local.inheritorData.alive);
        }
      }
      );
      this.formModel.heirsList = this.heirs;
    },
    updateHeirsList(heirsList) {
      if (!this.formModel.heirsList)
        this.formModel.heirsList = [];
      (heirsList || []).forEach((item) => {
        this.formModel.heirsList.push(item);
      });
    },
    changeVerification(isVerified) {
      this.$set(this.formModel, 'isVerified', isVerified);
    },
  },
  mounted() {
    this.$set(this.formModel, 'heirsList', []);
  },

};
</script>
<style scoped>
.header-slot {
  position: absolute;
  margin: -17px 1500px;
}
.grid-actions {
  position: absolute;
  margin: -17px 1500px;
}
</style>
